/* eslint-disable no-console */
<template>

    <div class="main_unit">
        <pulse-loader class="w-100 text-center" :loading="isInitLoading"></pulse-loader>
        <div v-show="!isInitLoading">
            <div class="store_login_unit_manage_menu">企業管理者画面</div>
            <div class="store_tbl_unit wd976 tbl_ht_login_info tbl_bg_blue">
                <form class="form_checkSetting">
                    <div class="wd720">
                        <p class="checkSetting_text">衛生管理計画書設定</p><br>
                        <Message v-if="validationMessage || !addFormFlg" :validationMessage="alertMessage" /><br>
                        <Message v-if="validationMessage" :validationMessage="validationMessage" />
                    </div>
                    <div class="lavel_check_setting right_comment ">
                        <label for="plan">計画書</label>
                    </div>
                    <div class="input_store left_comment selectFile" id="plan">
                        <input v-if="this.planFile == null" class="wd400" name="plan1" type="text" disabled />
                        <input v-if="this.planFile !== null" class="wd400" name="plan2" type="text" disabled v-model="planFile['name']" />
                        <label class="selectFile__label">選択<input ref="input" type="file" accept="application/pdf" @change="selectPlanFiles($event)"></label>
                        <div style="margin-top: 10px">
                            <p id="plan_fill_name1" class="wd400 text_white_space_nowrap" style="display: inline-flex;">{{hygieneManagementPlan.planFilePath}}</p>
                            <label v-if="hygieneManagementPlan.planFilePath" class="selectFile__label" @click.prevent.stop="deletePlan()">削除</label>
                        </div>
                        <p id="plan_err1" class="lavel_error_font ">{{validation.planFilePathResult}}</p>
                        <p>※アップロードできるファイルサイズは500MBまでです</p>
                    </div>

                    <div class="lavel_check_setting right_comment ">
                        <label for="plan">遷移ボタン設定</label>
                    </div>

                    <div class="lavel_tyori right_comment">
                        <label for="diesplayAdd_id"></label>
                    </div>
                    <div class="admin_button_top_unit mgl_10" id="diesplayAdd_id">
                        <div class="checkSetting_buttan_unit ">
                            <div class="checkSetting_kanri_box ">
                                <ul class="ul_tbl_buttan"><li><a href="#" @click.prevent.stop="addColum">行追加</a></li></ul>
                            </div>
                        </div>
                    </div>

                    <div class="lavel_tyori right_comment">
                        <label for="diesplaySetList_id"></label>
                    </div>
                    <div  class="tbl_bg_blue mgt_15" name="pageSetting" id="diesplaySetList_id" >
                        <table class="checkSetting_tbl_unit wd750 Hygiene_setting_height mgl_24">
                            <tbody>
                                <tr>
                                    <th class="wd50"  style="text-align: center">表示順</th>
                                    <th class="wd265" style="text-align: center">ボタン名称</th>
                                    <th class="wd335" colspan="2" style="text-align: center">遷移先</th>
                                    <th class="wd80_fix_min"  style="text-align: center">削除</th>
                                </tr>
                            </tbody>

                            <tbody>
                                <tr v-for="(data,index) in transitionSetting" :key=data.topButtonId>
                                    <td  style="text-align: center">{{data.transitionPageNo}}</td>
                                    <td class="wd265 view_setting_text_td">
                                        <input type="text" class="view_setting_text_input w-100 h-100" maxlength="20" v-model="data.buttonName">
                                    </td>
                                    <td class="text_white_space" style="font-size: 13px;color: #000000;vertical-align: text-top">{{data.transitionPageName}}</td>
                                    <td class="wd80_fix_min">
                                        <div class="checkSetting_kanri_box">
                                            <ul class="ul_tbl_buttan"><li><a href="#" @click.prevent.stop="selectScreen(index)">設定</a></li></ul>
                                        </div>
                                    </td>
                                    <td class="wd80_fix_min">
                                        <div class="checkSetting_kanri_box ">
                                            <ul class="ul_tbl_buttan"><li><a href="#" @click.prevent.stop="delecSelect(index)">削除</a></li></ul>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>

                        </table>
                    </div>
                </form><br>
            </div>

            <div>
                <div class="btn_submit" style="text-align: center">
                    <ul class="set_ul_tbl_buttan" style="display: inline-block">
                        <li>
                            <router-link class="checkSetting_buttan_unit" :to="{ name: 'managemenu'} ">キャンセル</router-link>
                        </li>
                    </ul>
                    <ul class="set_ul_tbl_buttan" style="display: inline-block">
                        <li><a class="checkSetting_buttan_unit " href="#" @click.prevent.stop="asyncUpdatePlan">更新</a></li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="overlay" v-show="showContent">
            <div>
                <div class="modal_box wd512">
                    <div class="modal_header_unit">
                        <div class="modal_header_box">
                            <p class="checkSetting_text">衛生管理計画書設定</p>
                        </div>
                    </div>
                    <div class="modal_content_tex">
                        <p>衛生管理計画書設定の更新<br>
                            が完了しました。</p>
                    </div>

                    <div class="btn_submit_box">
                        <div class="btn_submit">
                            <a href="#" @click.prevent.stop="closeModel">OK</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="overlay" v-show="showContent1">
            <div>
                <div class="modal_box wd512">
                    <div class="modal_header_unit">
                        <div class="modal_header_box">
                            <p class="modal_header_tit">計画書削除</p>
                        </div>
                    </div>
                    <div class="modal_content_tex">
                        <p>計画書を削除しますか？
                        </p>
                    </div>
                    <div class="btn_submit_box">
                        <div class="btn_submit2">
                            <a href="#" @click.prevent.stop="closeModel1">キャンセル</a>
                        </div>
                        <div class="btn_submit">
                            <a href="#" @click.prevent.stop="asyncDeletedPlan">削除</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="overlay" v-show="showContent2">
            <div>
                <div class="modal_box wd512">
                    <div class="modal_header_unit">
                        <div class="modal_header_box">
                            <p class="modal_header_tit">計画書削除</p>
                        </div>
                    </div>
                    <div class="modal_content_tex">
                        <p>計画書削除が完了しました。</p>
                    </div>

                    <div class="btn_submit">
                        <a href="#" @click.prevent.stop="closeModel2">OK</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="overlay" v-show="showContent3">
            <div>
                <div class="modal_box wd800">
                    <div class="modal_header_unit">
                        <div class="modal_header_box">
                            <p class="modal_header_tit_s"> </p>
                            <p class="modal_header_tit">遷移先選択</p>
                        </div>
                        <div class="modal_header_left">
                            <a class="js-modal-close" role="button" @click.prevent.stop="closeModel3">閉じる</a>
                        </div>
                    </div>
                    <div class="wd700 mgt_20">
                        <div class="lavel_error_font mgb_5">{{validationModelMessage}}</div>
                        <div class="dialog_hygiene_unit">
                            <p class="dialog_hygiene_tit_select">TOPメニュー</p>
                            <td class="dialog_background-color_def dialog_select_scrren_wd">
                                <div class="cp_ipselect cp_sl01">
                                    <select class="dialog_select_area" v-model="SelectValueTopMenu" @change="changeSelectTopMenu">
                                        <option value=null disabled>TOPメニューを選択</option>
                                        <option v-for="topButton in topButtonSetting" :key="topButton.topButtonId" :value="topButton.topButtonId" :id="topButton.topButtonId">
                                            {{topButton.upperButtonName}} {{topButton.lowerButtonName}}</option>
                                    </select>
                                </div>
                            </td>
                        </div>
                        <div class="dialog_hygiene_unit">
                            <p class="dialog_hygiene_tit_select_page">ページ</p>
                            <td v-if="SelectValueTopMenu==null || SelectValueTopButtonNo!==2" class="dialog_background-color_disabled dialog_select_scrren_wd">
                                <div class="cp_ipselect cp_sl01">
                                    <select class="dialog_select_area" disabled>
                                        <option value=null>ページを選択</option>
                                    </select>
                                </div>
                            </td>
                            <td v-else class="dialog_background-color_def dialog_select_scrren_wd">
                                <div class="cp_ipselect cp_sl01">
                                    <select class="dialog_select_area" v-model="SelectValuePage">
                                        <option value=null disabled>ページを選択</option>
                                        <option v-for="cookButton in cookButtonSetting" :key="cookButton.cookingCheckButtonId" :value="cookButton.cookingCheckButtonId" :id="cookButton.cookingCheckButtonId">
                                            {{cookButton.upperButtonName}} {{cookButton.lowerButtonName}}</option>
                                    </select>
                                </div>
                            </td>
                        </div>
                    </div>
                    <div class="btn_submit letter_spa">
                        <a role="button" @click.prevent.stop="dialogOpenCheck()">登録</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="overlay_loder" v-show="isLoading">
            <pulse-loader class="w-100 text-center" :loading="isLoading"></pulse-loader>
        </div>
    </div>

</template>

<script>
    import PulseLoader from '@/app/components/PulseLoader.vue'
    import Message from '@/app/components/Message.vue'
    export default {
        name: "HygieneManagementPlanSetting",
        components: {
            PulseLoader,
            Message
        },
        data: function () {
            return {
                isLoading:false,
                isInitLoading:true,
                validationMessage:'',
                alertMessage:'入力エラーがあります。',
                showContent:false,
                showContent1:false,
                showContent2:false,
                showContent3:false,
                validation:{
                    planFilePathResult:"",
                },
                planFile: null,
                hygieneManagementPlan:{
                    hygieneManagementPlanId: null,
                    planFilePath: ''
                },
                brandId: '',
                deleteFlg: 0,
                addFormFlg: true,
                transitionSetting: [],
                topButtonSetting: [],
                cookButtonSetting: [],
                SelectValueTopMenu:null,        // topButtonSettingのtopButtonIdを格納
                SelectValueTopButtonNo:null,    // topButtonSettingのtopButtonNoを格納
                SelectValuePage:null,           // cookButtonSettingのcookingCheckButtonIdを格納
                selectIndex:null,               // transitionSettingの設定選択したindexNoを格納
                validationModelMessage:""
            }
        },
        computed:{
            brandPath: function () {
                return this.$store.getters['brand/path']
            },
        },
        created: function(){
            this.brandId = this.$store.getters['brand/id'];
            this.calc();
        },
        methods:{
            async calc(){

                var currentTime = this.getCurrentTime();

                // 衛生管理計画書設定取得API
                await this.$axios
                    .get(this.$apiEndpoint + 'manage/brand/' + this.brandId + '/hygiene_management_plan/setting', { params: { datetime: currentTime}})
                    .then(response => (this.hygieneManagementPlan = response.data.hygieneManagementPlan,
                            this.transitionSetting = response.data.transitionSetting,
                            this.topButtonSetting = response.data.topButtonSetting,
                            this.cookButtonSetting = response.data.cookButtonSetting
                    ))
                    .catch((err) => {
                        let error = {
                            button: {
                                path: {name: 'top', params:{brandPath: this.brandPath}}
                            }}

                        if (err.customError) {
                            error = Object.assign(error, err.customError)
                        }
                        this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                    }).finally(()=> this.isInitLoading = false);
            },
            async asyncUpdatePlan() {
                await this.asyncUpdate().then((apiResponseFlg) =>
                {
                    if(apiResponseFlg){
                        this.clearFile();
                        this.showContent = true;
                    }
                });
            },
            async asyncUpdate() {

                this.isLoading = true;
                this.validationMessage = '';
                var apiResponseFlg = true;

                // バリデーションチェック
                this.clearError();
                if(!this.validationCheck()){
                    this.isLoading = false;
                    return;
                }

                var configImCheck  = {
                    headers: {
                        'Content-Type': 'multipart/form-data;'
                    }
                };

                // request作成
                var requestBody = {
                    delete_flg : this.deleteFlg
                }
                if (this.planFile != null) {
                    requestBody.plan_file_path = this.planFile
                }
                if(this.transitionSetting.length != 0){
                    var transitionRequestArray = new Array();
                    for(var i = 0 ; i < this.transitionSetting.length ; i++){
                        var transitionSettingObj = new Object();
                        transitionSettingObj.top_button_id = this.transitionSetting[i].topButtonId
                        transitionSettingObj.menu_button_id = this.transitionSetting[i].menuButtonId
                        transitionSettingObj.transition_page_no = this.transitionSetting[i].transitionPageNo
                        transitionSettingObj.button_name = this.transitionSetting[i].buttonName
                        transitionRequestArray.push(transitionSettingObj);
                    }
                    requestBody.transition_setting = transitionRequestArray;
                }

                var formRequestBody = this.jsonToFormData(requestBody);

                // 衛生管理計画書設定更新API
                await this.$axios
                    .post(this.$apiEndpoint + 'manage/brand/' + this.brandId + '/hygiene_management_plan/setting', formRequestBody, configImCheck)
                    .then(response => (this.hygieneManagementPlan = response.data.hygieneManagementPlan))
                    .catch((err) => {
                        let error = {
                            button: {
                                path: {name: 'top', params:{brandPath: this.brandPath}}
                            }}
                        apiResponseFlg = false;
                        if (err.customError) {
                            error = Object.assign(error, err.customError);

                            if(error.code == 400){
                                this.validationMessage =  error.message;
                                this.scrollTop();
                            }
                        }
                        if(error.code !== 400){
                            this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                        }
                    }).finally(()=> this.isLoading = false);

                return apiResponseFlg;
            },
            closeModel() {
                this.showContent = false;
            },
            selectPlanFiles:function(event) {
                this.addFormFlg = true;
                //ファイル選択
                this.clearError();
                this.clearFile();

                let files = event.target.files[0];

                // ファイルの拡張子チェック
                if(files.type !== "application/pdf"){
                    this.validation.planFilePathResult = "PDFファイルを指定してください。";
                    this.scrollTop();
                    this.addFormFlg = false;
                    return null;
                }

                // ファイル名の長さをチェック
                if(String(files['name']).length > 260){
                    this.validation.planFilePathResult = "ファイル名(拡張子を含む)は、260桁以内で入力してください。";
                    this.scrollTop();
                    this.addFormFlg = false;
                    return null;
                }

                this.planFile = files;
                this.deleteFlg = 0;
                this.$refs.input.value = '';
            },
            jsonToFormData(data) {
                const formData = new FormData();

                this.buildFormData(formData, data);

                return formData;
            },
            clearError(){
                //メッセージ初期化
                this.validation.planFilePathResult = "";
                this.validationMessage = "";
            },
            clearFile(){
                //ファイル初期化
                this.planFile = null;
            },
            deletePlan(){
                this.showContent1 = true;
            },
            async asyncDeletedPlan() {
                this.showContent1 = false;

                this.clearFile();
                this.deleteFlg = 1;

                await this.asyncUpdate().then((apiResponseFlg) =>
                {
                    if(apiResponseFlg){
                        this.showContent2 = true;
                        this.$refs.input.value = '';
                        this.hygieneManagementPlan.planFilePath = '';
                    }
                });
            },
            closeModel1() {
                this.showContent1 = false;
            },
            closeModel2(){
                this.showContent2 = false;
            },
            closeModel3(){
                this.selectIndex = null;
                this.SelectValueTopMenu = null;
                this.SelectValuePage = null;
                this.showContent3 = false;
                this.validationModelMessage = "";
            },
            buildFormData(formData, data, parentKey) {
                if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
                    Object.keys(data).forEach(key => {
                        this.buildFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key);
                    });
                } else {
                    const value = data == null ? '' : data;
                    formData.append(parentKey, value);
                }
            },
            getCurrentTime() {
                // 当日日付をyyyymmddhhmmssで返却
                var now = new Date();
                var res = now.getFullYear() +
                    this.padZero(now.getMonth() + 1) +
                    this.padZero(now.getDate()) +
                    this.padZero(now.getHours()) +
                    this.padZero(now.getMinutes()) +
                    this.padZero(now.getSeconds());
                return res;
            },
            padZero(num) {
                //先頭ゼロ付加
                var result;
                if (num < 10) {
                    result = "0" + num;
                } else {
                    result = "" + num;
                }
                return result;
            },
            scrollTop() {
                window.scrollTo(0,0);
            },
            addColum(){

                if(this.transitionSetting.length >= 100 ){
                    this.validationMessage = '遷移先は100件まで登録可能です'
                    this.scrollTop();
                    return null;
                }

                var transitionSettingOjb = new Object();
                transitionSettingOjb['topButtonId'] = null;
                transitionSettingOjb['menuButtonId'] = null;
                transitionSettingOjb['transitionPageNo'] = this.transitionSetting.length + 1;
                transitionSettingOjb['buttonName'] ='';
                transitionSettingOjb['transitionPageName'] ='';

                this.transitionSetting.push(transitionSettingOjb);
            },
            delecSelect(indexCount){

                // 遷移先の削除
                var transitionSettingDataArray = [];
                transitionSettingDataArray = this.transitionSetting;
                transitionSettingDataArray.splice(indexCount,1);

                for(var i = 0 ; i < transitionSettingDataArray.length ; i++){
                    transitionSettingDataArray[i].transitionPageNo = i +1;
                }
                this.transitionSetting = transitionSettingDataArray;

            },
            selectScreen(index){

                // indexからデータを取得
                var transitionSettingDate = this.transitionSetting[index]

                // 遷移先未設定(遷移先名で判定)の場合、初期選択なし
                if(transitionSettingDate.transitionPageName !== ""){
                    this.SelectValueTopMenu = transitionSettingDate.topButtonId;
                    this.SelectValuePage = transitionSettingDate.menuButtonId;

                    // 遷移先設定のtopButtonIDからtopButtonNoを取得する
                    for(var i = 0 ; i < this.topButtonSetting.length ; i++){
                        if(this.topButtonSetting[i].topButtonId === transitionSettingDate.topButtonId){
                            this.SelectValueTopButtonNo = this.topButtonSetting[i].topButtonNo;
                            break;
                        }
                    }
                }

                this.selectIndex = index;
                this.showContent3 = true;
            },
            dialogOpenCheck(){

                this.validationModelMessage = "";
                if(this.SelectValueTopMenu === null){
                    this.validationModelMessage = "TOPメニューを選択してください";
                    return;
                }

                var topButtonSettingObj = new Object();
                // Top
                for(var i = 0 ; i < this.topButtonSetting.length ; i++){
                    if(this.topButtonSetting[i].topButtonId === this.SelectValueTopMenu){
                        topButtonSettingObj = this.topButtonSetting[i];
                        break;
                    }
                }

                if(topButtonSettingObj.topButtonNo === 2 && this.SelectValuePage === null){
                    this.validationModelMessage = "ページを選択してください";
                    return;
                }


                // 重要管理項目はcookButtonSettingも設定
                var cookButtonSettingobj = new Object();
                // 重要管理項目のみ検索を実施する
                if(this.SelectValueTopButtonNo === 2){
                    for(var k = 0 ; k < this.cookButtonSetting.length ; k++){
                        if(this.cookButtonSetting[k].cookingCheckButtonId === this.SelectValuePage){
                            cookButtonSettingobj = this.cookButtonSetting[k];
                            break;
                        }
                    }
                }

                this.transitionSetting[this.selectIndex].topButtonId = topButtonSettingObj.topButtonId;
                this.transitionSetting[this.selectIndex].transitionPageNo = this.selectIndex + 1;
                this.transitionSetting[this.selectIndex].transitionPageName = "";

                // 重要管理項目の場合のみ実施
                if(this.SelectValueTopButtonNo === 2){
                    this.transitionSetting[this.selectIndex].menuButtonId = cookButtonSettingobj.cookingCheckButtonId;
                    this.transitionSetting[this.selectIndex].transitionPageName = cookButtonSettingobj.upperButtonName + " " + cookButtonSettingobj.lowerButtonName;
                }
                else{
                    this.transitionSetting[this.selectIndex].menuButtonId = null;
                    this.transitionSetting[this.selectIndex].transitionPageName = topButtonSettingObj.upperButtonName + " " + topButtonSettingObj.lowerButtonName;
                }

                // 選択したパラメータを初期化
                this.selectIndex = null;
                this.SelectValueTopMenu = null;
                this.SelectValuePage = null;
                this.SelectValueTopButtonNo = null;

                // 選択画面を閉じる
                this.showContent3 = false;
            },
            changeSelectTopMenu(){
                // ページ項目初期化
                this.SelectValuePage = null;
                // TOPメニューのボタンNoをIDから判定して設定
                for(var i = 0 ; i < this.topButtonSetting.length ; i++){
                    if(this.topButtonSetting[i].topButtonId === this.SelectValueTopMenu){
                        this.SelectValueTopButtonNo = this.topButtonSetting[i].topButtonNo;
                        break;
                    }
                }
            },
            validationCheck(){
                // 遷移先設定がある場合のみ実施
                if(this.transitionSetting.length == 0){
                    return true;
                }
                else{

                    // 遷移先設定ボタン名称
                    var checkFlg = true;
                    for(var i = 0 ; i < this.transitionSetting.length ; i++){
                        if(this.transitionSetting[i].buttonName === ''){
                            this.validationMessage = "ボタン名称は必ず指定してください。";
                            checkFlg = false;
                            break;
                        }
                        if(this.transitionSetting[i].buttonName.length > 20){
                            this.validationMessage = "ボタン名称は20文字以内で入力してください。";
                            checkFlg = false;
                            break;
                        }
                        if(this.transitionSetting[i].transitionPageName === ''){
                            this.validationMessage = "遷移先は必ず指定してください。";
                            checkFlg = false;
                            break;
                        }
                    }

                    if(checkFlg){
                        // ボタン名称の重複確認
                        for(var h = 0 ; h < this.transitionSetting.length ; h++) {
                            // 次行がある場合の処理
                            if ((h + 1) !== this.transitionSetting.length) {
                                // 比較元のデータを取得
                                var transitionSettingObj = this.transitionSetting[h];

                                for (var k = h+1; k < this.transitionSetting.length; k++) {
                                    if (transitionSettingObj.buttonName == this.transitionSetting[k].buttonName) {
                                        this.validationMessage = "ボタン名称には異なった値を指定してください。";
                                        checkFlg = false;
                                        break;
                                    }
                                }
                            }
                            if(!checkFlg){
                                break;
                            }
                        }
                    }

                    return checkFlg;
                }
            }
        }
    }
</script>

<style scoped>

</style>